import { Navigate, RouteObject } from 'react-router-dom';

import { pagePathSegments } from '~constants';
import KeyGroupDetailsPage from '~features/keyGroups/pages/keyGroupDetailsPage';

const keygroupRoutes = (): RouteObject[] => {
	return [
		{
			path: pagePathSegments.KeyGroups,
			children: [
				{
					// For now redirect to the keys page, since we don't have a page for
					// all key groups yet.
					index: true,
					element: <Navigate to={`../${pagePathSegments.Keys}`} replace />,
				},
				{ path: ':id', element: <KeyGroupDetailsPage /> },
			],
		},
	];
};

export default keygroupRoutes;
